import { render, staticRenderFns } from "./communitySpaceConfirmList.vue?vue&type=template&id=dc541952&scoped=true"
import script from "./communitySpaceConfirmList.vue?vue&type=script&lang=js"
export * from "./communitySpaceConfirmList.vue?vue&type=script&lang=js"
import style0 from "./communitySpaceConfirmList.vue?vue&type=style&index=0&id=dc541952&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc541952",
  null
  
)

export default component.exports